import React, { useEffect, useState } from 'react';
import { api } from '../../app/Api/ApiSlice';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import RequestingBranchCard from '../../components/RequestingBranchCard';

// requesting to be parent
const BranchesJoinRequesting = () => {
    const [orgs, setOrgs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const { organization } = useParams();

    useEffect(() => {
        const getBranchJoinRequestsReceived = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/${organization}/branches/requests/received`, {
                    params: { page },
                });

                const newBranches = response.data.branchJoinRequests.received;

                setOrgs((prev) =>
                    page === 1 ? newBranches : [...prev, ...newBranches]
                );

                // If fewer items are returned than expected, assume no more pages
                if (newBranches.length === 0 || newBranches.length < 10) {
                    setHasMore(false);
                }
            } catch (error) {
                console.log(error)
                toast.error(error?.response?.data?.message || 'Something went wrong');
                setHasMore(false);
            } finally {
                setIsLoading(false);
            }
        };

        getBranchJoinRequestsReceived();
    }, [page, organization]);

    const handleRefresh = async () => {
        setPage(1);
        setHasMore(true);
    };

    return (
        <div>
            {<h2 className='page-header-title'>Received Branch join requests</h2>}
            <InfiniteScroll
                dataLength={orgs.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                pullDownToRefresh
                pullDownToRefreshThreshold={50}
                pullDownToRefreshContent={
                    <h4 style={{ textAlign: 'center' }}>↓ Pull down to refresh</h4>
                }
                releaseToRefreshContent={
                    <h4 style={{ textAlign: 'center' }}>↑ Release to refresh</h4>
                }
                loader={<Loader />}
            >
                {orgs.length > 0 ? (
                    orgs.map((b) => (
                        <div className="add-branch-container" key={b.id}>
                            <RequestingBranchCard b={b} />
                        </div>
                    ))
                ) : (
                    !isLoading && <p className='not-found-msg'>No organizations requested to be branches</p>
                )}
            </InfiniteScroll>
        </div>
    );
};

export default BranchesJoinRequesting;
